// extracted by mini-css-extract-plugin
module.exports = {"popover_menu":"popover-menu_popover_menu__ggVVC"};